import styled from 'styled-components';

export const HeaderContainer = styled.header`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1000;

	width: 100%;

	.content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		padding: 2.4rem 0;

		h1 {
			position: relative;
			z-index: 10;

			color: #fff;

			svg {
				width: 5rem;
				height: auto;
			}
		}

		nav {
			ul {
				display: flex;
				align-items: center;
				gap: 2.8rem;

				li {
					list-style: none;

					a {
						display: flex;
						align-items: center;
						gap: 0.4rem;

						font-size: var(--text-size);

						&:hover {
							color: #fff;
							text-decoration: underline;
						}
					}
				}
			}
		}
	}

	@media (max-width: 820px) {
	}

	@media (max-width: 720px) {
		nav {
			position: fixed;
			top: 0;
			left: 0;

			display: flex;
			align-items: center;
			justify-content: center;

			width: 100%;
			height: 100%;
			padding: 13rem 5.5% 8rem;

			background: var(--color-background);
			border-bottom: 1px solid var(--color-line);

			ul {
				display: flex;
				flex-direction: column;
				align-items: center !important;
				justify-content: center;
				gap: 2.4rem;

				li {
					a {
						text-align: center;
						font-size: calc(var(--text-size) + 0.4rem) !important;
					}
				}
			}

			opacity: 0;
			pointer-events: none;
			user-select: none;
			transition: 0.2s;

			&.active {
				opacity: 1;
				pointer-events: auto;
			}
		}

		#menu-burger {
			position: relative;
			z-index: 100;
			--factor: 0.45;

			background: transparent;

			label {
				transform: scaleX(-1);

				display: flex;
				flex-direction: column;
				width: calc(70px * var(--factor));
				cursor: pointer;

				span {
					background: #fff;
					border-radius: calc(10px * var(--factor));
					height: calc(5px * var(--factor));
					margin: calc(7px * var(--factor)) 0;
					transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);

					&:nth-of-type(1) {
						width: 50%;
					}

					&:nth-of-type(2) {
						width: 100%;
					}

					&:nth-of-type(3) {
						width: 75%;
					}
				}

				input[type='checkbox'] {
					display: none;

					&:checked ~ span:nth-of-type(1) {
						transform-origin: bottom;
						transform: rotatez(45deg)
							translate(
								calc(8px * var(--factor)),
								calc(0px * var(--factor))
							);
					}

					&:checked ~ span:nth-of-type(2) {
						transform-origin: top;
						transform: rotatez(-45deg);
					}

					&:checked ~ span:nth-of-type(3) {
						transform-origin: bottom;
						width: 50%;
						transform: translate(
								calc(28px * var(--factor)),
								calc(-11px * var(--factor))
							)
							rotatez(45deg);
					}
				}
			}
		}
	}
`;

export default HeaderContainer;
